<template>
  <page-outline :title="$t('businessMembers.add_member')"
    iconF7="person_round">

    <template slot="pageContent">
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="login" isMandatory
            :inputLabel="$t('administration.user_login')" :placeholderValue="$t('administration.user_login')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input isMandatory
            :inputLabel="$t('rights.rights_profile')"
            inputType="listeSelect">
            <select class="form-control" id="sel4" v-model="selectedConfig" readonly>
              <option :value="{}">{{ $t('rights.select_profile') }}</option>
              <option v-for="config in configList"
                :key="config.idProfile"
                :value="config">
                {{ config.libelleProfile }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row class="form-group justify-content-end mr-5">
        <b-col lg="2">
          <b-button
            variant="primary" size="lg"
            @click="addAccountMember">
            <i class="fa-light fa-plus"></i>
            <span>{{ $t('common.add_label') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddAccountMember',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      login: '',
      status: '',
      configList: [],
      selectedConfig: {},
      usedConfig: {}
    }
  },
  created () {
    let that = this
    that.$engine.rights.getAllProfiles().then(resp => {
      if (resp.profiles) {
        that.configList = resp.profiles
        let usedConfig = that.configList.find(config => {
          if (config.users) {
            return config.users.find(user => {
              return user === that.login
            })
          }
        })
        if (usedConfig) {
          that.previousProfilId = usedConfig.idProfile
          that.selectedConfig = usedConfig
        }
      }
    })
  },
  methods: {
    addAccountMember () {
      this.$f7.showPreloader('')
      let that = this
      if (that.login !== '') {
        that.$engine.accounts.addUserToAccount(that.login, that.selectedConfig.idProfile)
          .then(response => {
            if (response.status === 200) {
              that.$f7.hidePreloader()
              this.$f7.closeModal()
              that.$f7.alert('User correctly added', 'Success')
              this.$bus.$emit('refresh-cache-account-members')
              loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
            }
          })
          .catch(err => {
            errorMessageAlert(err, that)
          })
      } else {
        this.$f7.hidePreloader()
        this.$f7.alert('', 'Data empty')
      }
    }
  }
}
</script>
